
/** 混入方法 ::: 
 *  @mixins mixRenderItemTemplateProtocol 渲染表单线协议
 */
import { mixRenderItemTemplateProtocol } from "@/mixins/render_item/mix_render_item_template_protocol.js";


/** @name 渲染预览表单项协议 
 *  @author 王汝鹏
 *  @version 2019-11-30
 */
export const mixRenderItemTemplateProtocolRealize = {
  mixins: [ mixRenderItemTemplateProtocol ],
  computed: {
    /** 协议数据 ::: 
     *  @return {Object} formModels 表单填写内容
     *  @return {Object} formMap 表单项字典
     */
    render_item_template_store: { 
      get() {
        let mix_rice_preview_render_store = this.mix_rice_preview_render_store;
        return {
          get formModels() { return mix_rice_preview_render_store.formModels; },
          set formModels(newValue) { mix_rice_preview_render_store.formModels = newValue; },
          get formMap() { return mix_rice_preview_render_store.formMap; }
        }
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/mixins/rice_preview_render/mix_rice_preview_render_protocol_realize.js